import { Spin } from 'antd';
import classNames from 'classnames';
import React from 'react';

const Loading = ({global}) => {
    return (
        <div className={classNames('loading-container', {
            "loading-container--global": global
        })}>
            <Spin size='medium' className='spin-global' />
        </div>
    );
};

export default Loading;